module.exports = __webpack_public_path__ + "img/api.92ecb05.png";